
import { get } from 'lodash-es';
import { each } from 'lodash-es';
import { mapValues } from 'lodash-es';
import { mapKeys } from 'lodash-es';
import { omitBy } from 'lodash-es';

class LibraryDataMapper {
    constructor(router, data, update, isClearance) {
        this.router = router;
        this.data = data;
        this.update = update;
        this.isClearance = isClearance

        router.app.$watch('$route.query', this.generate.bind(this));
    }

    boot() {
        this.generate(this.router.app.$route.query);
    }

    generate(query) {
        const search = get(query, 'filter[search]', '');

        this.data.search = search.replace(/\+|( )+/g, ' ').trim();
        this.data.paginator = {
            page: Number(get(query, 'page', 1)),
            perPage: Math.min(get(query, 'per_page', 28), 56),
        };

        this.generateSort(query);
        this.generateFilters(query);

        this.update();
    }

    generateSort(query) {
        let sortBy = this.isClearance ? 'Price' : 'Name',
        sortDirection = 'asc',
        sortQuery = get(query, 'sort', null);

        if (sortQuery) {
            sortDirection = 0 === sortQuery.indexOf('-') ? 'desc' : 'asc';

            if ('desc' === sortDirection) {
                sortQuery = sortQuery.slice(1);
            }

            sortBy = sortQuery[0].toUpperCase() + sortQuery.slice(1);

            if (-1 === ['Name', 'Sku', 'Price'].indexOf(sortBy)) {
                sortBy = 'Name';
            }

            if ('Sku' === sortBy) {
                sortBy = 'SKU';
            }
        }

        this.data.sort = {
            sortBy: sortBy,
            sortDirection: sortDirection,
        };
    }

    generateFilters(query) {
        const prefix = 'filter[';
        const prefixLength = prefix.length;

        const filtered = omitBy(query, (v, k) => 0 !== k.indexOf(prefix));

        const keyed = mapKeys(filtered, (v, k) => {
            let key = k.substr(prefixLength, k.length - prefixLength - 1);

            return key;
        });

        const checkable = omitBy(keyed, (v, k) => 'Search' === k);

        let checked = {};

        each(checkable, (v, k) => {
            const options = v.split(',').map(v => v.replace(/ /g, '+'));

            let selected = {};

            each(options, v => selected[v] = true);

            checked[k] = selected;

            return selected;
        });

        this.data.filtered = checked;
    }
}

export default LibraryDataMapper;
